export default __webpack_public_path__ + "static/media/dishes.bd4d930c.svg";